import React from 'react';
import { RouteObject } from '../../util/types';
import { Deposits } from './Deposits.page';

export const routes: RouteObject[] = [
  {
    path: '/secure/bank/deposits',
    render: props => <Deposits {...props}></Deposits>,
  },
];
